/** 🔮 might want to have this stored in redux store for theming... but also keep in mind css custom properties... maybe redux would set the custom properties... to persist user preference */
export default {
  accent1: 'firebrick',
  highlight: '#fbf99a',
  link: '#0066c0',
};



// WEBPACK FOOTER //
// ./src/constants/colors.js